import React, { useState, useEffect, useContext } from "react"
import { store } from '../stores/team_pages'
import classNames from "classnames"
import LoadingIndicator from "./shared/LoadingIndicator"
import GraphicImagePreview from "./shared/GraphicImagePreview"
import { Clipboard, Copy, ExternalLink, Menu, Settings, Trash2 } from "react-feather"
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, UncontrolledTooltip } from "reactstrap"
import DeletePageModal from "./TeamPages/DeletePageModal"
import { CopyToClipboard } from 'react-copy-to-clipboard'

export default function Page({ page, unlink, onClick, hideMenu, pageClasses: sentPageClasses }) {
  const {
    basename,
    hideEdit,
    hideDuplicate,
    hideDelete,
  } = useContext(store)

  const [copyText, setCopyText] = useState("Copy Link")

  const setCopiedText = () => {
    setCopyText("Copied!")
    setTimeout(() => {
      setCopyText("Copy Link")
    }, 3000)
  }

  const { formats, generating, preview_urls, title, published, url } = page.attributes
  // Get the sizes to enforce text truncation on the title
  const [isTitleOverflowing, setIsTitleOverflowing] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const duplicateLink = `${basename}/new/${page.attributes.template_id}?duplicate=${page.id}`

  const extraPageClasses = sentPageClasses || []

  useEffect(() => {
    const element = document.getElementById(`pageTitleFor-${page.id}`)
    if (element) {
      setIsTitleOverflowing(element.scrollWidth > element.clientWidth)
    }
  }, [title])

  const firstFormat = formats[0]

  const textWidth = () => {
    const type = firstFormat.extension
    const width = firstFormat.width
    const height = firstFormat.height
    const typeHeight = type === "png" ? 180 : 200

    // Return a square if it is a portrait orientation
    const ratio = width < height ? 1 : width / height

    return `calc(${typeHeight * ratio}px - (${iconSize}px + (2 * var(--space-2))) )`
  }

  const editLink = `${basename}/${page.id}/edit`
  const link = !unlink

  const linkData = {
    external: true,
    href: link ? editLink : false,
    class: "graphic-preview",
  }

  const pageClasses = classNames(["graphic", ...extraPageClasses])
  const imageClasses = classNames(["graphic-preview-image"])
  const iconSize = 16
  const dropdownItemClasses = classNames([
    "d-flex",
    "align-center",
    "gap-2",
    "lh-sm",
  ])

  const openDeleteModal = () => {
    setDeleteOpen(true)
  }

  const closeDeleteModal = () => {
    setDeleteOpen(false)
  }

  return (
    <div className="graphic-react-wrapper">
      <div className={pageClasses}>
        <div className="graphic-preview-container">
          <LoadingIndicator
            title="Generating…"
            loading={generating}
            color="dark"
            textColor="text-white"
          />
          <div className={`graphic-preview-item graphic-preview-item-${firstFormat.extension}${generating ? " graphic-preview-item-generating" : ""}`}>
            <GraphicImagePreview
              src={preview_urls[firstFormat.id]}
              height={firstFormat.extension == "png" ? 180 : 200}
              alt={title}
              loading="eager"
              imageClasses={imageClasses}
              ratio={`${firstFormat.width} / ${firstFormat.height}`}
              graphic={page}
              link={linkData}
              onClick={onClick}
              tags={published ? [{text: "Published", color: "success"}] : [{text: "Draft", color: "warning"}]}
              hidePreview={true}
            />
          </div>
        </div>
        <div className="graphic-details">
          <div
            className="graphic-details__title"
            id={`pageTitleFor-${page.id}`}
            style={{ "--width": textWidth() }}
          >
            {title}
          </div>
          {isTitleOverflowing && (
            <UncontrolledTooltip
              target={`pageTitleFor-${page.id}`}
              placement="bottom"
            >
              {title}
            </UncontrolledTooltip>
          )}
          {!hideMenu && (
            <div className="graphic-details__controls">
              <UncontrolledDropdown direction="up" a11y={false}>
                <DropdownToggle color="link" className="p-2 m-n2 text-muted">
                  <Menu size="16" />
                </DropdownToggle>
                <DropdownMenu end={true} className="mx-3 p-0">
                  {!hideEdit && (
                    <DropdownItem tag="a" href={editLink} className={dropdownItemClasses}>
                      <Settings size={iconSize} /> Edit
                    </DropdownItem>
                  )}
                  {!hideDuplicate && (
                    <DropdownItem
                      tag="a"
                      href={duplicateLink}
                      className={dropdownItemClasses}
                    >
                      <Copy size={iconSize} /> Duplicate
                    </DropdownItem>
                  )}
                  {published && (
                    <DropdownItem
                      tag="a"
                      href={url}
                      className={dropdownItemClasses}
                    >
                      <ExternalLink size={iconSize} /> Visit Page
                    </DropdownItem>
                  )}
                  {published && (
                    <CopyToClipboard
                      text={url}
                      onCopy={setCopiedText}
                    >
                      <Button color="link" className="dropdown-item">
                        <Clipboard size={iconSize} className="me-1 icon-valign" />{" "}
                        {copyText}
                      </Button>
                    </CopyToClipboard>
                  )}
                  {!hideDelete && (
                    <DropdownItem
                      onClick={openDeleteModal}
                      className={`${dropdownItemClasses} dropdown-item--danger`}
                    >
                      <Trash2 size={iconSize} /> Delete
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
              <DeletePageModal
                page={page}
                isOpen={deleteOpen}
                close={closeDeleteModal}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
